export const unhandledCase = (unreachable: never) =>
  new Error(`unhandled case ${JSON.stringify(unreachable)}`);

export const unimplemented = () => new Error("unimplemented");
